import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Document, Page } from 'react-pdf'; // Import Document and Page from react-pdf
import { jwtDecode } from 'jwt-decode';
import './DepartmentDashboard.css';


const DepartmentDashboard = () => {
  const { id: departmentId } = useParams();
  const navigate = useNavigate();

  //const [error, setError] = useState(null);

  const [department, setDepartment] = useState(null);
  const [introduction, setIntroduction] = useState("");
  const [newIntroduction, setNewIntroduction] = useState("");
  const [chairmanMessage, setChairmanMessage] = useState("");
  const [newChairmanMessage, setNewChairmanMessage] = useState("");
  const [chairmanImage, setChairmanImage] = useState(null);
  const [newChairmanImage, setNewChairmanImage] = useState(null);
  const [vision, setVision] = useState("");
  const [newVision, setNewVision] = useState("");
  const [mission, setMission] = useState("");
  const [newMission, setNewMission] = useState("");
  const [peos, setPEOs] = useState("");
  const [newPEOs, setNewPEOs] = useState("");
  const [sliders, setSliders] = useState([]);
  const [newSliderImage, setNewSliderImage] = useState(null);
  const [newSliderCaption, setNewSliderCaption] = useState("");
  const [newSliderDescription, setNewSliderDescription] = useState("");
  const [research, setResearch] = useState([]);
  const [newResearchImage, setNewResearchImage] = useState(null);
  const [newResearchTitle, setNewResearchTitle] = useState("");
  const [newResearchDescription, setNewResearchDescription] = useState("");
  const [newsEvents, setNewsEvents] = useState([]);
  const [newNewsEventImage, setNewNewsEventImage] = useState(null);
  const [newNewsEventTitle, setNewNewsEventTitle] = useState("");
  const [newNewsEventDescription, setNewNewsEventDescription] = useState("");
  const [newNewsEventDate, setNewNewsEventDate] = useState("");
  const [circulars, setCirculars] = useState([]);
  const [newCircularImage, setNewCircularImage] = useState(null);
  const [newCircularTitle, setNewCircularTitle] = useState("");
  const [newCircularDescription, setNewCircularDescription] = useState("");
  const [pdfFile, setPdfFile] = useState(null); // State to hold the PDF file
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const validateToken = () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setError("Unauthorized access. Please log in.");
        navigate("/login");
        return;
      }
  
      try {
        const decodedToken = jwtDecode(token);
        console.log("Decoded Token:", decodedToken);
  
        // Fix the validation logic
        if (
          decodedToken.loginType !== "department" || // Use loginType instead of userType
          decodedToken.id !== parseInt(departmentId, 10) // Compare id from the token
        ) {
          throw new Error("Access denied for this department.");
        }
  
        console.log("Access granted for department:", departmentId);
      } catch (error) {
        console.error("Token validation error:", error.message);
        setError("Access denied. Please log in.");
        navigate("/login");
      }
    };
  
    validateToken();
  }, [departmentId, navigate]);

  useEffect(() => {
    const fetchData = async (url, setState, errorMessage) => {
      try {
        const token = localStorage.getItem("authToken");
        const response = await fetch(url, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
    
        if (!response.ok) {
          console.error(`${errorMessage}:`, await response.text());
          return;
        }
    
        const data = await response.json();
        setState(data);
        console.log(`Response from ${url}:`, data);
      } catch (err) {
        console.error(`Error fetching data from ${url}:`, err.message);
      }
    };


    if (departmentId) {
      fetchData(
        `http://121.52.154.120:3001/api/departments/${departmentId}`,
        setDepartment,
        "Failed to load department details."
      );
      fetchData(
        `http://121.52.154.120:3001/api/dept-sliders/${departmentId}`,
        setSliders,
        "Failed to load sliders."
      );
      fetchData(
        `http://121.52.154.120:3001/api/dept-research/${departmentId}`,
        setResearch,
        "Failed to load research projects."
      );
      fetchData(
        `http://121.52.154.120:3001/api/dept-circulars-info/${departmentId}`,
        setCirculars,
        "Failed to load circulars."
      );
      fetchData(
        `http://121.52.154.120:3001/api/dept-news-events/${departmentId}`,
        setNewsEvents,
        "Failed to load news and events."
      );
      fetchData(
        `http://121.52.154.120:3001/api/dept-details/introduction/${departmentId}`,
        (data) => setIntroduction(data.introduction || "No introduction found.")
      );
      fetchData(
        `http://121.52.154.120:3001/api/dept-details/chairman-message/${departmentId}`,
        (data) => setChairmanMessage(data.chairmanMessage || "No chairman message found.")
      );
      setChairmanImage(
        `http://121.52.154.120:3001/api/dept-details/chairman-image/${departmentId}`
      );
      fetchData(
        `http://121.52.154.120:3001/api/dept-details/vision/${departmentId}`,
        (data) => setVision(data.vision || "No vision found.")
      );
      fetchData(
        `http://121.52.154.120:3001/api/dept-details/mission/${departmentId}`,
        (data) => setMission(data.missionStatement || "No mission statement found.")
      );
      fetchData(
        `http://121.52.154.120:3001/api/dept-details/peos/${departmentId}`,
        (data) => setPEOs(data.PEOs || "No PEOs found.")
      );
    }
  }, [departmentId]);


  return (
    <div className="page-container">
      <h1>Department Dashboard</h1>
      {error && <p className="error-message">{error}</p>}
  
      {department ? (
        <div className="department-info">
          <h2>Department Name: {department.deptname}</h2>
          <h3>Department ID: {department.id}</h3>
        </div>
      ) : (
        <p>Loading department details...</p>
      )}
  
      {/* Introduction Section */}
      <section className="upload-section">
        <h2 className="section-header">Introduction</h2>
        <p>{introduction || "No introduction available for this department."}</p>
        <textarea
          className="custom-textarea"
          value={newIntroduction}
          onChange={(e) => setNewIntroduction(e.target.value)}
          placeholder="Add or update introduction..."
        />
        <button
          onClick={async () => {
            setIsLoading(true);
            try {
              const token = localStorage.getItem("authToken");
              const response = await fetch(
                "http://121.52.154.120:3001/api/dept-details/introduction",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                  },
                  body: JSON.stringify({
                    departmentId: Number(departmentId),
                    introduction: newIntroduction,
                  }),
                }
              );
  
              if (!response.ok) {
                throw new Error(await response.text());
              }
  
              const updatedData = await response.json();
              setIntroduction(updatedData.introduction || newIntroduction);
              setNewIntroduction("");
              setError("");
            } catch (error) {
              console.error("Error updating introduction:", error.message);
              setError("Failed to update introduction. Please try again.");
            } finally {
              setIsLoading(false);
            }
          }}
          disabled={isLoading}
          className="update-button"
        >
          {isLoading ? "Updating..." : "Update Introduction"}
        </button>
      </section>
  
      {/* Chairman Message Section */}
      <section className="upload-section">
        <h2 className="section-header">Chairman Message</h2>
        <p>{chairmanMessage || "No chairman message available for this department."}</p>
        <textarea
          className="custom-textarea"
          value={newChairmanMessage}
          onChange={(e) => setNewChairmanMessage(e.target.value)}
          placeholder="Add or update chairman message..."
        />
        <button
          onClick={async () => {
            setIsLoading(true);
            try {
              const token = localStorage.getItem("authToken");
              const response = await fetch(
                "http://121.52.154.120:3001/api/dept-details/chairman-message",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                  },
                  body: JSON.stringify({
                    departmentId: Number(departmentId),
                    chairmanMessage: newChairmanMessage,
                  }),
                }
              );
  
              if (!response.ok) {
                throw new Error(await response.text());
              }
  
              const updatedData = await response.json();
              setChairmanMessage(updatedData.chairmanMessage || newChairmanMessage);
              setNewChairmanMessage("");
              setError("");
            } catch (error) {
              console.error("Error updating chairman message:", error.message);
              setError("Failed to update chairman message. Please try again.");
            } finally {
              setIsLoading(false);
            }
          }}
          disabled={isLoading}
          className="update-button"
        >
          {isLoading ? "Updating..." : "Update Chairman Message"}
        </button>
      </section>
  
      {/* Vision Section */}
      <section className="upload-section">
        <h2 className="section-header">Vision</h2>
        <p>{vision || "No vision available for this department."}</p>
        <textarea
          className="custom-textarea"
          value={newVision}
          onChange={(e) => setNewVision(e.target.value)}
          placeholder="Add or update vision..."
        />
        <button
          onClick={async () => {
            setIsLoading(true);
            try {
              const token = localStorage.getItem("authToken");
              const response = await fetch(
                "http://121.52.154.120:3001/api/dept-details/vision",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                  },
                  body: JSON.stringify({
                    departmentId: Number(departmentId),
                    vision: newVision,
                  }),
                }
              );
  
              if (!response.ok) {
                throw new Error(await response.text());
              }
  
              const updatedData = await response.json();
              setVision(updatedData.vision || newVision);
              setNewVision("");
              setError("");
            } catch (error) {
              console.error("Error updating vision:", error.message);
              setError("Failed to update vision. Please try again.");
            } finally {
              setIsLoading(false);
            }
          }}
          disabled={isLoading}
          className="update-button"
        >
          {isLoading ? "Updating..." : "Update Vision"}
        </button>
      </section>
  
      {/* Mission Section */}
      <section className="upload-section">
        <h2 className="section-header">Mission Statement</h2>
        <p>{mission || "No mission statement available for this department."}</p>
        <textarea
          className="custom-textarea"
          value={newMission}
          onChange={(e) => setNewMission(e.target.value)}
          placeholder="Add or update mission statement..."
        />
        <button
          onClick={async () => {
            setIsLoading(true);
            try {
              const token = localStorage.getItem("authToken");
              const response = await fetch(
                "http://121.52.154.120:3001/api/dept-details/mission",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                  },
                  body: JSON.stringify({
                    departmentId: Number(departmentId),
                    missionStatement: newMission,
                  }),
                }
              );
  
              if (!response.ok) {
                throw new Error(await response.text());
              }
  
              const updatedData = await response.json();
              setMission(updatedData.missionStatement || newMission);
              setNewMission("");
              setError("");
            } catch (error) {
              console.error("Error updating mission statement:", error.message);
              setError("Failed to update mission statement. Please try again.");
            } finally {
              setIsLoading(false);
            }
          }}
          disabled={isLoading}
          className="update-button"
        >
          {isLoading ? "Updating..." : "Update Mission"}
        </button>
      </section>
  
      {/* PEOs Section */}
      <section className="upload-section">
        <h2 className="section-header">Program Educational Objectives (PEOs)</h2>
        <p>{peos || "No PEOs available for this department."}</p>
        <textarea
          className="custom-textarea"
          value={newPEOs}
          onChange={(e) => setNewPEOs(e.target.value)}
          placeholder="Add or update PEOs..."
        />
        <button
          onClick={async () => {
            setIsLoading(true);
            try {
              const token = localStorage.getItem("authToken");
              const response = await fetch(
                "http://121.52.154.120:3001/api/dept-details/peos",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                  },
                  body: JSON.stringify({
                    departmentId: Number(departmentId),
                    PEOs: newPEOs,
                  }),
                }
              );
  
              if (!response.ok) {
                throw new Error(await response.text());
              }
  
              const updatedData = await response.json();
              setPEOs(updatedData.PEOs || newPEOs);
              setNewPEOs("");
              setError("");
            } catch (error) {
              console.error("Error updating PEOs:", error.message);
              setError("Failed to update PEOs. Please try again.");
            } finally {
              setIsLoading(false);
            }
          }}
          disabled={isLoading}
          className="update-button"
        >
          {isLoading ? "Updating..." : "Update PEOs"}
        </button>
      </section>

  {/* Sliders Section */}
{/* Table Section for Sliders */}
<section className="upload-section">
  <h2 className="section-header">Sliders</h2>
  <div className="slider-upload">
    <input
      type="file"
      onChange={(e) => setNewSliderImage(e.target.files[0])}
      className="custom-input"
    />
    <input
      type="text"
      value={newSliderCaption}
      onChange={(e) => setNewSliderCaption(e.target.value)}
      placeholder="Add slider caption..."
      className="custom-input"
    />
    <textarea
      value={newSliderDescription}
      onChange={(e) => setNewSliderDescription(e.target.value)}
      placeholder="Add slider description..."
      className="custom-textarea"
    />
    <button
      onClick={async () => {
        if (!newSliderImage) {
          setError("Please select an image to upload.");
          return;
        }
        setIsLoading(true);
        const formData = new FormData();
        formData.append("departmentId", departmentId);
        formData.append("image", newSliderImage);
        formData.append("caption", newSliderCaption.trim() || "");
        formData.append("detail", newSliderDescription.trim() || "");

        try {
          const response = await fetch(
            "http://121.52.154.120:3001/api/dept-sliders",
            { method: "POST", body: formData }
          );

          if (!response.ok) throw new Error(await response.text());
          const data = await response.json();
          setSliders((prevSliders) => [data.slider, ...prevSliders]);
          setNewSliderImage(null);
          setNewSliderCaption("");
          setNewSliderDescription("");
          setError("");
        } catch (error) {
          console.error("Error uploading slider:", error.message);
          setError("Failed to upload slider. Please try again.");
        } finally {
          setIsLoading(false);
        }
      }}
      disabled={isLoading}
      className="update-button"
    >
      {isLoading ? "Uploading..." : "Add Slider"}
    </button>
  </div>

  <div className="table-container">
    <table>
      <thead>
        <tr>
          <th>Thumbnail</th>
          <th>Caption</th>
          <th>Description</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {sliders.map((slider) => (
          <tr key={slider.id}>
            <td>
              <img
                src={`http://121.52.154.120:3001${slider.imageUrl}`}
                alt={slider.caption}
                className="thumbnail"
              />
            </td>
            <td>{slider.caption}</td>
            <td>{slider.detail}</td>
            <td>
              <button
                onClick={async () => {
                  setIsLoading(true);
                  try {
                    const response = await fetch(
                      `http://121.52.154.120:3001/api/dept-sliders/${slider.id}`,
                      { method: "DELETE" }
                    );

                    if (!response.ok) throw new Error(await response.text());
                    setSliders((prevSliders) =>
                      prevSliders.filter((item) => item.id !== slider.id)
                    );
                  } catch (error) {
                    console.error("Error deleting slider:", error.message);
                    setError("Failed to delete slider. Please try again.");
                  } finally {
                    setIsLoading(false);
                  }
                }}
                disabled={isLoading}
                className="delete-button"
              >
                {isLoading ? "Deleting..." : "Delete"}
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</section>

  {/* Circulars Section */}
<section className="upload-section">
  <h2 className="section-header">Circulars</h2>
  <div className="circular-upload">
    <input
      type="file"
      onChange={(e) => setNewCircularImage(e.target.files[0])}
      className="custom-input"
    />
    <input
      type="text"
      value={newCircularTitle}
      onChange={(e) => setNewCircularTitle(e.target.value)}
      placeholder="Add circular title..."
      className="custom-input"
    />
    <textarea
      value={newCircularDescription}
      onChange={(e) => setNewCircularDescription(e.target.value)}
      placeholder="Add circular description..."
      className="custom-textarea"
    />
    <button
      onClick={async () => {
        if (!newCircularImage) {
          setError("Please select an image to upload.");
          return;
        }
        setIsLoading(true);
        const formData = new FormData();
        formData.append("departmentId", departmentId);
        formData.append("image", newCircularImage);
        formData.append("title", newCircularTitle.trim() || "");
        formData.append("description", newCircularDescription.trim() || "");

        try {
          const response = await fetch(
            "http://121.52.154.120:3001/api/dept-circulars-info",
            { method: "POST", body: formData }
          );

          if (!response.ok) throw new Error(await response.text());
          const data = await response.json();
          setCirculars((prevCirculars) => [...prevCirculars, data]);
          setNewCircularImage(null);
          setNewCircularTitle("");
          setNewCircularDescription("");
          setError("");
        } catch (error) {
          console.error("Error uploading circular:", error.message);
          setError("Failed to upload circular. Please try again.");
        } finally {
          setIsLoading(false);
        }
      }}
      disabled={isLoading}
      className="update-button"
    >
      {isLoading ? "Uploading..." : "Add Circular"}
    </button>
  </div>

  <div className="table-container">
    <table>
      <thead>
        <tr>
          <th>Thumbnail</th>
          <th>Title</th>
          <th>Description</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {circulars.map((circular) => (
          <tr key={circular.id}>
            <td>
              <img
                src={`http://121.52.154.120:3001${circular.imageUrl}`}
                alt={circular.title}
                className="thumbnail"
              />
            </td>
            <td>{circular.title}</td>
            <td>{circular.description}</td>
            <td className="action-buttons">
              <button
                onClick={() => {
                  console.log(`Editing circular ID: ${circular.id}`);
                  // Add editing logic here if required
                }}
                className="edit-button"
              >
                Edit
              </button>
              <button
                onClick={async () => {
                  setIsLoading(true);
                  try {
                    const response = await fetch(
                      `http://121.52.154.120:3001/api/dept-circulars-info/${circular.id}`,
                      { method: "DELETE" }
                    );

                    if (!response.ok) throw new Error(await response.text());
                    setCirculars((prevCirculars) =>
                      prevCirculars.filter((item) => item.id !== circular.id)
                    );
                  } catch (error) {
                    console.error("Error deleting circular:", error.message);
                    setError("Failed to delete circular. Please try again.");
                  } finally {
                    setIsLoading(false);
                  }
                }}
                disabled={isLoading}
                className="delete-button"
              >
                {isLoading ? "Deleting..." : "Delete"}
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</section>


{/* News and Events Section */}
<section className="upload-section">
  <h2 className="section-header">News and Events</h2>
  <div className="news-events-upload">
    <input
      type="file"
      onChange={(e) => setNewNewsEventImage(e.target.files[0])}
      className="custom-input"
    />
    <input
      type="text"
      value={newNewsEventTitle}
      onChange={(e) => setNewNewsEventTitle(e.target.value)}
      placeholder="Add event title..."
      className="custom-input"
    />
    <textarea
      value={newNewsEventDescription}
      onChange={(e) => setNewNewsEventDescription(e.target.value)}
      placeholder="Add event description..."
      className="custom-textarea"
    />
    <input
      type="date"
      value={newNewsEventDate}
      onChange={(e) => setNewNewsEventDate(e.target.value)}
      className="custom-input"
    />
    <button
      onClick={async () => {
        if (!newNewsEventImage) {
          setError("Please select an image to upload.");
          return;
        }
        setIsLoading(true);
        const formData = new FormData();
        formData.append("departmentId", departmentId);
        formData.append("image", newNewsEventImage);
        formData.append("title", newNewsEventTitle.trim() || "");
        formData.append("description", newNewsEventDescription.trim() || "");
        formData.append("eventDate", newNewsEventDate || null);

        try {
          const response = await fetch(
            "http://121.52.154.120:3001/api/dept-news-events",
            { method: "POST", body: formData }
          );

          if (!response.ok) throw new Error(await response.text());
          const data = await response.json();
          setNewsEvents((prevNewsEvents) => [...prevNewsEvents, data]);
          setNewNewsEventImage(null);
          setNewNewsEventTitle("");
          setNewNewsEventDescription("");
          setNewNewsEventDate("");
          setError("");
        } catch (error) {
          console.error("Error uploading news event:", error.message);
          setError("Failed to upload news event. Please try again.");
        } finally {
          setIsLoading(false);
        }
      }}
      disabled={isLoading}
      className="update-button"
    >
      {isLoading ? "Uploading..." : "Add Event"}
    </button>
  </div>

  <div className="table-container">
    <table>
      <thead>
        <tr>
          <th>Thumbnail</th>
          <th>Title</th>
          <th>Description</th>
          <th>Date</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {newsEvents.map((event) => (
          <tr key={event.id}>
            <td>
              <img
                src={`http://121.52.154.120:3001${event.imageUrl}`}
                alt={event.title}
                className="thumbnail"
              />
            </td>
            <td>{event.title}</td>
            <td>{event.description}</td>
            <td>{event.eventDate}</td>
            <td className="action-buttons">
              <button
                onClick={() => {
                  console.log(`Editing event ID: ${event.id}`);
                  // Add editing logic here if required
                }}
                className="edit-button"
              >
                Edit
              </button>
              <button
                onClick={async () => {
                  setIsLoading(true);
                  try {
                    const response = await fetch(
                      `http://121.52.154.120:3001/api/dept-news-events/${event.id}`,
                      { method: "DELETE" }
                    );

                    if (!response.ok) throw new Error(await response.text());
                    setNewsEvents((prevNewsEvents) =>
                      prevNewsEvents.filter((item) => item.id !== event.id)
                    );
                  } catch (error) {
                    console.error("Error deleting event:", error.message);
                    setError("Failed to delete event. Please try again.");
                  } finally {
                    setIsLoading(false);
                  }
                }}
                disabled={isLoading}
                className="delete-button"
              >
                {isLoading ? "Deleting..." : "Delete"}
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</section>

{/* Research Section */}
<section className="upload-section">
  <h2 className="section-header">Research</h2>
  <div className="research-upload">
    <input
      type="file"
      onChange={(e) => setNewResearchImage(e.target.files[0])}
      className="custom-input"
    />
    <input
      type="text"
      value={newResearchTitle}
      onChange={(e) => setNewResearchTitle(e.target.value)}
      placeholder="Add research title..."
      className="custom-input"
    />
    <textarea
      value={newResearchDescription}
      onChange={(e) => setNewResearchDescription(e.target.value)}
      placeholder="Add research description..."
      className="custom-textarea1"
    />
    <button
      onClick={async () => {
        if (!newResearchImage) {
          setError("Please select an image to upload.");
          return;
        }
        setIsLoading(true);
        const formData = new FormData();
        formData.append("departmentId", departmentId);
        formData.append("image", newResearchImage);
        formData.append("title", newResearchTitle.trim() || "");
        formData.append("description", newResearchDescription.trim() || "");

        try {
          const response = await fetch(
            "http://121.52.154.120:3001/api/dept-research",
            { method: "POST", body: formData }
          );

          if (!response.ok) throw new Error(await response.text());
          const data = await response.json();
          setResearch((prevResearch) => [...prevResearch, data]);
          setNewResearchImage(null);
          setNewResearchTitle("");
          setNewResearchDescription("");
          setError("");
        } catch (error) {
          console.error("Error uploading research:", error.message);
          setError("Failed to upload research. Please try again.");
        } finally {
          setIsLoading(false);
        }
      }}
      disabled={isLoading}
      className="update-button"
    >
      {isLoading ? "Uploading..." : "Add Research"}
    </button>
  </div>

  <div className="table-container">
    <table>
      <thead>
        <tr>
          <th>Thumbnail</th>
          <th>Title</th>
          <th>Description</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {research.map((item) => (
          <tr key={item.id}>
            <td>
              <img
                src={`http://121.52.154.120:3001${item.imageUrl}`}
                alt={item.title}
                className="thumbnail"
              />
            </td>
            <td>{item.title}</td>
            <td>{item.description}</td>
            <td>
              <button
                onClick={async () => {
                  setIsLoading(true);
                  try {
                    const response = await fetch(
                      `http://121.52.154.120:3001/api/dept-research/${item.id}`,
                      { method: "DELETE" }
                    );

                    if (!response.ok) throw new Error(await response.text());
                    setResearch((prevResearch) =>
                      prevResearch.filter((research) => research.id !== item.id)
                    );
                  } catch (error) {
                    console.error("Error deleting research:", error.message);
                    setError("Failed to delete research. Please try again.");
                  } finally {
                    setIsLoading(false);
                  }
                }}
                disabled={isLoading}
                className="delete-button"
              >
                {isLoading ? "Deleting..." : "Delete"}
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</section>





    
</div>
  );

}  
export default DepartmentDashboard;
